import React from "react";

export default function Shrp({ className }) {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          className={className}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1565 45.5043C54.1129 46.7333 53.1347 48.9697 52.7929 49.7224C49.8256 56.5043 38.1129 60.177 27.8402 64.9952C15.2838 70.9043 7.77836 78.737 7.98563 79.0534C8.1929 79.3697 18.0947 70.6024 33.4656 65.8752C38.3892 64.3588 52.8292 63.7697 63.262 57.3224C67.4474 54.7334 72.462 51.3188 76.8656 45.1406C81.1601 39.1152 84.5456 30.7515 89.342 30.9079C90.4329 30.9406 91.4656 31.4024 91.6256 31.0824C91.9892 30.3879 88.0838 26.137 84.0692 25.9915C77.8874 25.7588 74.6983 34.8388 68.7965 36.537C60.2038 39.3006 56.1638 29.0497 41.9129 31.617C31.9783 34.2752 33.1311 45.0061 22.9493 48.8424C17.3711 50.9479 11.8838 49.2061 11.7056 50.0752C11.4293 51.4133 21.8874 57.4279 30.8583 54.2897C36.782 52.217 38.9529 47.2315 47.4547 45.1588C51.2365 44.2279 52.5965 44.7879 53.1565 45.5043Z"
          fill="current-color"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="84"
            height="53.0909"
            fill="white"
            transform="translate(8 26)"
            className={className}
          />
        </clipPath>
      </defs>
    </svg>
  );
}
